<template>
  <v-select
    :items="thirdPartyPortalsList"
    item-value="id"
    item-text="thirdPartyPortalName"
    v-model="ThirdPartyPortalIdValue"
    label="Third Party Portal"
    :clearable="clearable ? clearable : false"
    :disabled="disabled ? disabled : false"
    :readonly="readonly ? readonly : false"
    :rules="[requiredCheck()]"
    outlined
  ></v-select>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'id',
    'isRequired',
    'disabled',
    'readonly',
    'clearable'
  ],
  computed: {
    ...mapFields('thirdPartyPortals', [
      'thirdPartyPortalsList'
    ]),
    ThirdPartyPortalIdValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('ThirdPartyPortalIdChange', newValue)
      }
    }
  },
  methods: {
    ...mapActions('thirdPartyPortals', [
      'getThirdPartyPortalsList'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Third Party Portal')
    }
  },
  created () {
    this.getThirdPartyPortalsList()
  }
}
</script>
